import React from 'react';
import { Typography, Row,  Space, Spin, Modal as AntModal, Flex, } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './Modal.css';

const { Title } = Typography;

export const Modal = (props) => {

    const {
        title,
        subtitle,
        icon,
        color,
        justifyTitle,
        width,
        extra,
        loading, 
        loadingMessage,
        ...other } = props;
    
    let modalElementId = props?.title ? props?.title?.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').replace(/^-|-$/g, '') + "-modal" : 'modal__container';

    const modalIcon = icon ? <span className="modal__icon" style={{color: `${color}`}}>{icon}</span> : '';

    return (
        <AntModal 
            id={modalElementId}
            footer={!props.actionGroup ? null : undefined}
            zIndex={2000}
            open={props.visible}
            onCancel={() => props.setVisible(false)}
            closable={!props.loading}
            maskClosable={!props.loading}
            width={props?.width || 400}
            classNames={props?.className}
            styles={props?.styles}
            style={props?.style}
            title={
                <Row className="modal__header" justify={justifyTitle} style={{marginBottom: 10, marginTop: title ? 20 : -10}}>
                    {modalIcon}
                    <Row justify='space-between'>
                        <Space direction='vertical' style={{textAlign: 'center'}}>
                            <Title className='--default' style={{margin: 0}} level={4}>{props.title}</Title>
                            {props.subtitle ? <Title level={5}>{props.subtitle}</Title> : null}
                        </Space>
                        {extra}
                    </Row>
                </Row>
            }
            >
            { props.loading ? 
                <Flex justify='center' vertical align='center' gap='middle' style={{textAlign: 'center'}}>
                    <Spin spinning={props.loadingSpinner} indicator={<LoadingOutlined spin style={{fontSize: 48}}/>}/>
                    {loadingMessage}
                </Flex>
            : 
                <>
                    {props.children}
                </>
            }
        </AntModal>
    )
}

Modal.defaultProps = {
    visible: false, 
    setVisible: false,
    extra: false,
    loading: false,
    loadingMessage: 'Please wait...',
}